import React from "react";
import AmCharts from "@amcharts/amcharts3-react";

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  render() {
    if (this.chart !== null) {
      this.chart.animateAgain();
    }
    const inRangeColor = "#32D630", // Green
      underRangeColor = "#FFD630", // Yellow
      overRangeColor = "#D63230",
      guideFillColor = "#00cc00",
      guideLineColor = "#00cc00"; // Red

    const { selectedGraph } = this.props;

    if (!selectedGraph || selectedGraph.length === 0 || !selectedGraph[0].referencia) {
      return <div style={{ color: "red", marginTop: "0.5em"}}>No hay graficos para mostrar en el rango de fechas</div>;
    }

    let graphReference = selectedGraph[0].referencia.trim().split(" - ");

    const yMin = Number(graphReference[0]);
    const yMax = Number(graphReference[1]);
    let unit = selectedGraph[0].unidad;

    selectedGraph.forEach(e => {
      // const tempDate = e.fecha_recepcion.substring(0, 10);
      // e.fecha_recepcion = tempDate;

      if (e.resultado === "-" || e.resultado === null) {
        e.resultado = 0;
      }
      const tempResult = e.resultado.toString().match(/^\d+\.?\d{0,2}/g); // Get the number from results and removes the other characters

      e.resultado = tempResult;
    });

    selectedGraph.map(e => {
      e.resultado = e.resultado === null ? "0.0" : e.resultado;
      if (yMin <= e.resultado && e.resultado <= yMax) {
        e.color = inRangeColor; // Green
      } else if (e.resultado < yMin) {
        e.color = underRangeColor; // Yellow
      } else if (e.resultado > yMax) {
        e.color = overRangeColor; // Red
      }
      return e;
    });

    let config = {
      type: "serial",
      startDuration: 1,
      startEffect: "easeOutSine",
      sequencedAnimation: true,
      listeners: [
        {
          event: "init",
          method: e => {
            this.chart = e.chart;
          }
        }
      ],
      legend: {
        data: [
          {
            title: `Menor a ${yMin} ${unit}`,
            color: underRangeColor
          },
          {
            title: `Mayor a ${yMax} ${unit}`,
            color: overRangeColor
          },
          {
            title: `Dentro del rango`,
            color: inRangeColor
          }
        ],
        position: "top"
      },
      // titles: [{ size: 15, text: nombrePrueba }],
      guides: [
        {
          fillAlpha: 0.1,
          value: yMin,
          toValue: yMax,
          // lineThickness: 4,
          fillColor: guideFillColor,
          lineColor: guideLineColor
        }
      ],
      dataProvider: selectedGraph,
      export: {
        enabled: true
      },
      // responsive: { enabled: true },
      valueAxes: [
        {
          position: "left",
          includeGuidesInMinMax: true
        }
      ],
      graphs: [
        {
          balloonText: "[[category]]: <b>[[value]]</b>",
          fillColorsField: "color",
          fillAlphas: 1,
          lineAlpha: 0.1,
          type: "column",
          valueField: "resultado"
        }
      ],
      // depth3D: 10,
      // angle: 30,
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: "fecha_recepcion",
      categoryAxis: {
        gridPosition: "start",
        labelRotation: -45
      }
    };

    return (
      <AmCharts.React
        style={{
          width: "100%",
          height: "400px"
        }}
        options={config}
      />
    );
  }
}

export default Chart;
